import { vars } from '@repo/config';
import { createPostFetchOptions } from './helper';

interface IRemoveUserResponse {
  success: boolean;
  error?: string;
}

export async function removeUser(
  cookieHeader: string,
  userId: string,
): Promise<IRemoveUserResponse> {
  const removeUrl = new URL('/api/auth/admin/remove-user', vars.url.identityUrl);
  const response = await fetch(
    removeUrl.toString(),
    createPostFetchOptions({
      cookieHeader,
      body: { userId },
    }),
  );

  if (!response.ok) {
    const errorData = (await response.json()) as { message?: string };
    return { success: false, error: errorData.message || 'Failed to delete user' };
  }

  return { success: true };
}
